import Header from "../components/common/Header";
import MHeader from "Components/mobile/common/MHeader";
import Footer from "../components/common/Footer";
import MFooter from "Components/mobile/common/MFooter";
import orderSubmitIcon from "../images/orderSubmit.svg";
import copyIcon from "../images/copy.svg";
import { Button, message } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import { getLocation, isMobile } from "../utils/common";
import configuration, { USER_TYPE, ORDER_CHANNEL, supplyCenterLtoHistoryListUrl, mobilityPendingLtoUrl, openTfsRuleUrl, openTfsChangeRuleUrl, AMOUNT_EXCEEDS_LIMIT, stockCenterMyOrdersUrl, stockCenterSelectCustomerUrl } from "../utils/constant";
import FooterNavBar from "Components/common/FooterNavBar";
import { useContext, useEffect } from "react";
import { pageDetailsDataPush } from "Utils/analyticsUtils";
import { AppContext } from "Store";
import infoIcon from "../images/info.svg";
const { URL_GLOBAL_ORDERHSITORY } = configuration;

const copyToClipboard = async (text: string) => {
  try {
    await navigator.clipboard?.writeText(text);
    message.success("复制成功");
  } catch (err) {
    console.error("Error in copying text: ", err);
  }
};

const OrderSuccess = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginState } = useContext(AppContext);
  useEffect(() => {
    const aaPageDetail = {
      type: "campaigns",
      name: 'campaigns:orderSuccess',
    };
    pageDetailsDataPush(aaPageDetail);
  }, []);
  const activityId = location.state?.activityId;
  const orderData = location.state?.data;
  const hasShipTo = location.state?.hasShipTo;
  const payableTotal = location.state?.payableTotal;
  const needConfirmChannelModule =
    loginState.userType === USER_TYPE.EMPLOYEE &&
    loginState?.proxyUser?.orderChannel === ORDER_CHANNEL.ONLINE;
  const isEmployeeOffline =
    loginState.userType === USER_TYPE.EMPLOYEE &&
    loginState?.proxyUser?.orderChannel === ORDER_CHANNEL.OFFLINE;
  const isEmployee = loginState.userType === USER_TYPE.EMPLOYEE;
  const showNotice = isEmployeeOffline;
  let webOrder = "",
    spOrder = "";
  let ltoOrder = "";
    console.log("orderData", orderData);
  orderData?.forEach((orderItem: any) => {
    if (orderItem.orderType === "SO" || orderItem.orderType === "SE") {
      webOrder = orderItem.salesOrderNumber;
    }
    if (orderItem.orderType === "D2" || orderItem.orderType === "CR") {
      spOrder = orderItem.salesOrderNumber;
    }
    if (orderItem.orderType === "LTO") {
      ltoOrder = orderItem.salesOrderNumber;
    }
  });
  const ltoConfirmLink =
    needConfirmChannelModule && ltoOrder
      ? `${configuration.APPLICATION_ENDPOINT}/my-orders/PendingLTO/${ltoOrder}`
      : mobilityPendingLtoUrl;
  //const cartTitle = previewDAta?.activityBasicType === "bundle_promotion" ? "已选套装" : "已选产品"

  return (
    <>
      {isMobile() ? <MHeader title='提交成功' /> :<Header />}
      <div className="successPage">
        <div className="successIconWrapper">
          <img alt="" src={orderSubmitIcon}></img>
        </div>
        <div className="msg">订单已提交</div>
        <div className="subMsg">
          {!!hasShipTo ? '': '订单已提交，审核流程可能需要1-3个工作日。审核完成后，我们会通过电子邮件通知您。'}
        </div>
        <div className="orderInfoWrapper">
          {needConfirmChannelModule && ltoOrder && (
            <div className="orderItem ltoOrderItem">
              <div className="ltoLine">
                <span className="ltoLabel">预购单号</span>
                <span className="ltoNumber" onClick={() => copyToClipboard(ltoOrder)}>
                  {ltoOrder}
                </span>
              </div>
              <div className="ltoLine linkLine">
                <span className="ltoLabel">客户确认链接：</span>
                <span
                  className="ltoLink"
                  onClick={() => {
                    copyToClipboard(ltoConfirmLink);
                  }}
                >
                  复制确认链接
                </span>
              </div>
            </div>
          )}
          {webOrder && (
            <div className="orderItem">
              <label className="orderTitle">大仓订单编号:</label>
              <span className="orderNumber">{webOrder}</span>
              <img
                alt="copy"
                src={copyIcon}
                onClick={() => {
                  copyToClipboard(webOrder);
                }}
              ></img>
            </div>
          )}
          {spOrder && (
            <div className="orderItem">
              <label className="orderTitle">现货中心订单编号</label>
              <span className="orderNumber">{spOrder}</span>
              <img
                alt="copy"
                src={copyIcon}
                onClick={() => {
                  copyToClipboard(spOrder);
                }}
              ></img>
            </div>
          )}
        </div>
        <div className="btnWrapper">
          <Button
            className="primaryBtn myOrderBtn"
            onClick={() => {
              if (needConfirmChannelModule && ltoOrder) {
                window.location.href = supplyCenterLtoHistoryListUrl;
                return;
              }

              if (isEmployee) {
                window.location.href = stockCenterMyOrdersUrl;
                return;
              }

              if (isMobile()) {
                window.location.href = `${getLocation()}/my-orders`;
              } else {
                window.open(URL_GLOBAL_ORDERHSITORY, "_blank");
              }
            }}
          >
            {needConfirmChannelModule && ltoOrder ? "我的预购单" : "我的订单"}
          </Button>
          <button
            className="primaryBtn continueBtn"
            onClick={() => {
              if (isEmployee) {
                window.location.href = stockCenterSelectCustomerUrl;
                return;
              }

              if (isMobile()) {
                // window.location.href = `${getLocation()}/campaigns/${activityId}/`;
                const searchParams = new URLSearchParams(location.search);
                activityId && navigate(`/m/${activityId}?${searchParams.toString()}`);
              } else {
                const searchParams = new URLSearchParams(location.search);
                activityId && navigate(`/${activityId}?${searchParams.toString()}`);
              }
            }}
          >
            继续购物
          </button>
        </div>
      </div>
      {isMobile() ? null: <FooterNavBar loginState={loginState}/>}
      {isMobile() ? <MFooter activityId={activityId}
       refreshCartCount={true}/>: <Footer />}
    </>
  );
};

export default OrderSuccess;
